import React from 'react';
import { robotIcon } from '../chatIcons';
import './GeneralProfileChatFlow.css';

export interface ProfileAssistantRowProps {
  children: React.ReactNode;
  animateIn?: boolean;
}

const ProfileAssistantRow: React.FC<ProfileAssistantRowProps> = ({ children, animateIn = false }) => (
  <div className={`gen-profile-chat__row ${animateIn ? 'gen-profile-chat__row--enter' : ''}`}>
    <div className="gen-profile-chat__avatar-wrap" aria-hidden>
      <img src={robotIcon} alt="" className="gen-profile-chat__avatar" />
    </div>
    <div className="gen-profile-chat__bubble-wrap">
      <div className="gen-profile-chat__bubble">{children}</div>
    </div>
  </div>
);

export default ProfileAssistantRow;
